module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 76
// module chunks = 0